import { memo } from "react";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import Animated, { AnimatedStyle, FadeIn, FadeOut } from "react-native-reanimated";
import { PressableScale } from "pressto";
import { View, Text, Checkbox, Button } from "@src/components";
import { ViewStyle } from "react-native";

interface FloatingSelectionBarProps {
  selectedCount: number;
  actionLabel: string;
  onAction: () => void;
  bottomInset: number;
  style?: AnimatedStyle<ViewStyle>;
}

export const FloatingSelectionBar = memo(
  ({ selectedCount, actionLabel, onAction, bottomInset, style }: FloatingSelectionBarProps) => {
    const { theme } = useUnistyles();

    if (selectedCount === 0) return null;

    return (
      <Animated.View
        entering={FadeIn}
        exiting={FadeOut}
        style={[styles.container, { marginBottom: bottomInset }, style]}
      >
        <View flexDirection="row" alignItems="center" gap="lg" py="md" px="lg">
          <Checkbox checked onToggle={() => {}} />
          <Text textStyle="sm/regular" color="text">
            {selectedCount} selected
          </Text>
        </View>
        <View
          flex={1}
          justifyContent="center"
          alignItems="center"
          padding="md"
          style={{ borderLeftWidth: 1, borderColor: theme.colors.borderCard }}
        >
          <Button variant="primary" label={actionLabel} onPress={onAction} />
        </View>
      </Animated.View>
    );
  },
);

const styles = StyleSheet.create((theme) => ({
  container: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: theme.colors.surfaceCard,
    borderWidth: 1,
    borderColor: theme.colors.borderCard,
    borderRadius: 12,
    position: "absolute",
    bottom: theme.spacing["3xl"],
    left: theme.spacing.xl,
    right: theme.spacing.xl,
    zIndex: 1,
    shadowColor: "#000000",
    shadowOffset: { width: 0, height: 1.5 },
    shadowOpacity: theme.currentTheme === "light" ? 0.15 : 0.45,
    shadowRadius: 49.8 / 2,
    elevation: 8,
  },
  actionButton: {
    height: 32,
    maxWidth: 108,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: theme.spacing.xl,
    borderRadius: theme.spacing.md,
    borderWidth: 1,
    borderColor: theme.colors.interactive.secondary.default_border,
    backgroundColor: theme.colors.interactive.secondary.background_secondary,
  },
}));
